import { useEffect, useState } from "react";
import { useLoginContext } from "../../../App";
import { fetchOrganizationUsersPaged } from "../../../services/b2b-users-apiService";
import { showNotification } from "../../b2b-common/Notification";
import { useContentContext } from "../../layout/Layout";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";

const useGetOrganizationMembers = (page = 1) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-users');

    const [organizationMembers, setOrganizationMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    

    const getOrganizationMembers = async () => {
        if (page < 1) return;
        setLoading(true);
        try {
            const orgUsers = await fetchOrganizationUsersPaged(loginData.accessToken, loginData.loggedOrganizationUuid, page - 1, 12);
            orgUsers.content.sort((a, b) => new Date(b.lastLoginDate) - new Date(a.lastLoginDate));
            if (orgUsers) {
                setOrganizationMembers(orgUsers);
            }
        } catch (error) {
            console.error('Error fetching organization members:', error);
            showNotification(setNotification, t('Error fetching organization members'), 'error', 5000);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (loginData) {
            getOrganizationMembers();
        }
    }, [loginData, page]);

    useEffect(() => {
        if (refresh) {
            getOrganizationMembers();
            setRefresh(false);
        }
    }, [refresh]);

    const triggerRefresh = () => {
        setRefresh(true);
    };    

    return { organizationMembers, loading, triggerRefresh };
}

export default useGetOrganizationMembers;